var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "page"
  }, [_c("div", {
    staticStyle: {
      width: "100px",
      "margin-right": "20px"
    }
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("理赔流程")))]), _c("a-steps", {
    attrs: {
      direction: "vertical"
    }
  }, [_c("a-step", {
    attrs: {
      status: _vm.step == 1 ? "process" : "finish"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("div", {
    staticClass: "title-custom",
    attrs: {
      title: _vm.$t("报案理赔")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("报案理赔")) + " ")])]), _c("a-icon", {
    attrs: {
      slot: "icon",
      type: "container"
    },
    slot: "icon"
  })], 2), _c("a-step", {
    attrs: {
      status: _vm.step == 2 ? "process" : _vm.step <= 1 ? "wait" : "finish"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("div", {
    staticClass: "title-custom",
    attrs: {
      title: _vm.$t("审核受理")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("审核受理")) + " ")])]), _c("a-icon", {
    attrs: {
      slot: "icon",
      type: "solution"
    },
    slot: "icon"
  })], 2), _c("a-step", {
    attrs: {
      status: _vm.step == 3 ? "process" : _vm.step <= 2 ? "wait" : "finish"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("div", {
    staticClass: "title-custom",
    attrs: {
      title: _vm.$t("邮寄单证")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("邮寄单证")) + " ")])]), _c("a-icon", {
    attrs: {
      slot: "icon",
      type: "file"
    },
    slot: "icon"
  })], 2), _c("a-step", {
    attrs: {
      status: _vm.step == 4 ? "process" : _vm.step <= 3 ? "wait" : "finish"
    }
  }, [_c("template", {
    slot: "title"
  }, [_c("div", {
    staticClass: "title-custom",
    attrs: {
      title: _vm.$t("结案")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("结案")) + " ")])]), _c("a-icon", {
    attrs: {
      slot: "icon",
      type: "file-done"
    },
    slot: "icon"
  })], 2)], 1)], 1), _vm.scheduleList.length != 0 ? _c("div", {
    staticStyle: {
      width: "200px",
      "overflow-y": "auto"
    }
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("理赔进度")))]), _c("a-timeline", _vm._l(_vm.scheduleList, function (item) {
    return _c("a-timeline-item", {
      key: item.id,
      attrs: {
        color: item.userName ? "green" : "blue"
      }
    }, [_c("p", {
      staticStyle: {
        cursor: "pointer"
      },
      style: item.id == _vm.scheduleInfo.id ? "color:#1890ff" : "",
      on: {
        click: function ($event) {
          return _vm.goInfoFun(item);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm._f("typeFilters")(item.type, _vm.tag, _vm.currentThis)) + " ")]), item.userName ? _c("p", [_vm._v(_vm._s(_vm.$t("操作人")) + ":" + _vm._s(item.userName))]) : _vm._e(), item.userName ? _c("p", [_vm._v(_vm._s(item.updateAt))]) : _vm._e()]);
  }), 1)], 1) : _vm._e(), _c("div", {
    staticClass: "infoBox",
    staticStyle: {
      flex: "1"
    }
  }, [_c("div", {
    staticClass: "name",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v(_vm._s(_vm._f("nameFilters")(this.scheduleInfo, _vm.tag, _vm.currentThis)))]), _vm.showCont ? _c("div", {
    staticClass: "operationBox"
  }, [_vm.scheduleInfo.type == 3 && !_vm.scheduleInfo.userName && _vm.tag == 0 ? _c("perfect-info", {
    attrs: {
      claimsReviewId: _vm.scheduleInfo.typeId
    },
    on: {
      ok: _vm.getScheduleFun
    }
  }) : _vm._e(), _vm.scheduleInfo.type == 1 || _vm.scheduleInfo.type == 2 || _vm.scheduleInfo.type == 4 || _vm.scheduleInfo.type == 3 && _vm.scheduleInfo.userName && _vm.tag == 0 || _vm.scheduleInfo.type == 5 || _vm.scheduleInfo.type == 6 || _vm.scheduleInfo.type == 10 ? _c("info", {
    attrs: {
      type: _vm.scheduleInfo.type,
      claimsReviewId: _vm.scheduleInfo.typeId
    }
  }) : _vm._e(), _vm.scheduleInfo.type == 8 && !_vm.scheduleInfo.userName && _vm.tag == 0 ? _c("mail-write", {
    attrs: {
      claimsId: _vm.scheduleInfo.claimsId
    },
    on: {
      ok: _vm.getScheduleFun
    }
  }) : _vm._e(), _vm.scheduleInfo.type == 8 && _vm.scheduleInfo.userName && _vm.tag != 1 ? _c("see-mail", {
    attrs: {
      claimsId: _vm.scheduleInfo.claimsId,
      edit: _vm.scheduleList[_vm.scheduleList.length - 1].type == 9 ? true : false
    },
    on: {
      save: _vm.getScheduleFun
    }
  }) : _vm._e(), (_vm.scheduleInfo.type == 7 || _vm.scheduleInfo.type == 9) && !_vm.scheduleInfo.userName && _vm.tag != 1 || _vm.scheduleInfo.type == 3 && _vm.tag != 0 || _vm.scheduleInfo.type == 8 && !_vm.scheduleInfo.userName && _vm.tag != 0 ? _c("div", {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [_c("a-result", {
    attrs: {
      status: "warning"
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c("img", {
          staticStyle: {
            width: "80px"
          },
          attrs: {
            src: require("../../../assets/wait.png")
          }
        })];
      },
      proxy: true
    }, {
      key: "extra",
      fn: function () {
        return [_vm.scheduleInfo.type == 7 ? _c("div", {
          staticClass: "cont"
        }, [_vm._v(" " + _vm._s(_vm.$t("审核已通过,应保险公司要求,该案件需要邮寄物理单证复核"))), _c("br"), _vm._v(_vm._s(_vm.$t("请等待保司回传邮寄信息")) + " ")]) : _vm._e(), _vm.scheduleInfo.type == 9 ? _c("div", {
          staticClass: "cont"
        }, [_vm._v(" " + _vm._s(_vm.$t("请等待保险公司操作结案")) + " ")]) : _vm._e(), _vm.scheduleInfo.type == 3 ? _c("div", {
          staticClass: "cont"
        }, [_vm._v(" " + _vm._s(_vm.$t("请等待客户完善资料")) + " ")]) : _vm._e(), _vm.scheduleInfo.type == 8 ? _c("div", {
          staticClass: "cont"
        }, [_vm._v(" " + _vm._s(_vm.$t("请等待客户邮寄信息")) + " ")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 3207176755)
  })], 1) : _vm._e(), _vm.scheduleInfo.type == 9 && !_vm.scheduleInfo.userName && _vm.tag == 1 ? _c("close-case", {
    attrs: {
      claimsId: _vm.scheduleInfo.claimsId
    },
    on: {
      ok: _vm.getScheduleFun
    }
  }) : _vm._e(), _vm.scheduleInfo.type == 8 && _vm.scheduleInfo.userName && _vm.tag == 1 ? _c("see-mail-bao-si", {
    attrs: {
      claimsId: _vm.scheduleInfo.claimsId
    },
    on: {
      ok: _vm.getScheduleFun
    }
  }) : _vm._e(), _vm.scheduleInfo.type == 7 && _vm.scheduleInfo.userName || _vm.scheduleInfo.type == 7 && _vm.tag == 1 ? _c("mail", {
    attrs: {
      claimsId: _vm.scheduleInfo.claimsId,
      edit: !_vm.scheduleInfo.userName ? true : false
    },
    on: {
      ok: _vm.getScheduleFun
    }
  }) : _vm._e()], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };